import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './get-first-contact-for-account.reducers';
import { GetFirstContactForAccountEffects } from './get-first-contact-for-account.effects';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ GetFirstContactForAccountEffects ]),
    StoreModule.forFeature('getFirstContactForAccount', reducer),
  ]
})
export class GetFirstContactForAccountModule {
}
